import { render, staticRenderFns } from "./MeasurementsSummary.vue?vue&type=template&id=ecc58f1c"
import script from "./MeasurementsSummary.vue?vue&type=script&lang=ts"
export * from "./MeasurementsSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports